/**
 * Template « Éditorial » — blanc, épuré, sérieux. Porté 1:1 depuis le
 * fichier de référence (menu-templates.html, `.editorial` + fonction
 * `editorial(m)`). Ce template n'affiche pas d'emoji par ligne (fidèle à la
 * référence) — juste libellé + prix, façon carte de prix minimaliste.
 */
import { forwardRef } from "react";

import type { MenuCardData } from "../types";
import { PortraitPlaceholder } from "./PortraitPlaceholder";

export const EditorialTemplate = forwardRef<HTMLDivElement, { data: MenuCardData }>(
  function EditorialTemplate({ data }, ref) {
    return (
      <div
        ref={ref}
        style={{
          boxSizing: "border-box",
          width: "100%",
          aspectRatio: "4 / 5",
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          background: "#fbf9f4",
          color: "#17130d",
          padding: "26px 26px 22px",
          fontFamily: '"Helvetica Neue", Arial, sans-serif',
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14 }}>
          <div>
            <h2 style={{ fontFamily: "Georgia, serif", fontSize: 30, lineHeight: 0.98, letterSpacing: "-0.01em", margin: 0, fontWeight: 400 }}>
              {data.name}
            </h2>
          </div>
          <div style={{ width: 96, height: 96, borderRadius: 6, overflow: "hidden", flex: "none", border: "1px solid #e4ddcf" }}>
            {data.photoUrl ? (
              <img
                src={data.photoUrl}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            ) : (
              <PortraitPlaceholder bg="#efe9dd" fg="#cfc6b4" />
            )}
          </div>
        </div>
        <div style={{ height: 1, background: "#e0d8c8", margin: "16px 0 8px" }} />
        <ul style={{ listStyle: "none", margin: 0, padding: 0, flex: 1 }}>
          {data.lines.map((line, i) => (
            <li
              key={line.id}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "baseline",
                gap: 10,
                padding: "8.5px 0",
                borderBottom: i === data.lines.length - 1 ? "none" : "1px solid #efe9dd",
              }}
            >
              <span style={{ fontSize: 13.5, letterSpacing: "0.02em" }}>{line.label}</span>
              <span style={{ fontSize: 14, fontWeight: 500, fontVariantNumeric: "tabular-nums" }}>
                {line.price}
              </span>
            </li>
          ))}
        </ul>
        <div
          style={{
            fontSize: 10,
            letterSpacing: "0.24em",
            textTransform: "uppercase",
            color: "#a99f8c",
            textAlign: "center",
            marginTop: 14,
          }}
        >
          Girlfriend expérience disponible
        </div>
      </div>
    );
  },
);
